<template>
  <div v-if="text" class="ErrorText">
    <Error class="ErrorIcon" />
    <div class="Text">{{ text }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Error } from "@ka-nabellinc/ka-nabell-icons";

export default defineComponent({
  components: {
    Error,
  },
  props: {
    text: {
      type: String,
      default: '',
    }
  }
})
</script>

<style scoped>
.ErrorText {
  display: flex;
  gap: 4px;
}

.ErrorIcon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  flex-basis: 20px;
}

.Text {
  position: relative;
  width: 100%;
  font-size: 11px;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.11px;
  color: var(--semantic-colors-border-error);
  top: 1px; 
}
</style>